<template>
  <div class="animated fadeIn disable-text-select" @keyup.enter="onFilter"
    style="overflow: auto;  padding-bottom: 6rem; padding-left: 4px; padding-right: 4px;">
    <div class="form-group row">
      <div class="w-100">
        <label style="font-size: medium; font-weight: 600;letter-spacing: 0.3px; color: #2e6e60; cursor: pointer"
          @click.prevent="showFilterAssociado === true ? showFilterAssociado = false : showFilterAssociado = true">
          <i v-if="showFilterAssociado" class="fas fa-caret-down"></i>
          <i v-else class="fas fa-caret-right"></i>
          Associado</label>
        <!-- <div style="display: block; position: relative;top: -15px; color: #787878"><small>Campanha em rede sociais</small> </div>-->
      </div>
    </div>
    <div v-if="showFilterAssociado">
      <div class="form-group row">
        <div class="w-100">
          <label> CPF/CNPJ:</label>
          <div class="input-group">
            <b-form-input type="text" :placeholder="'Digite o CPF ou CNPJ'" v-model="form.document.value"
              :state="form.document.state" autofocus />
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Nome:</label>
          <div class="input-group">
            <b-form-input type="text" :placeholder="'Digite o nome'" v-model="form.nome.value" :state="form.nome.state" />
          </div>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="w-100">
        <label style="font-size: medium; font-weight: 600;letter-spacing: 0.3px; color: #2e6e60; cursor: pointer"
          @click.prevent="showFilterInstituicao === true ? showFilterInstituicao = false : showFilterInstituicao = true">
          <i v-if="showFilterInstituicao" class="fas fa-caret-down"></i>
          <i v-else class="fas fa-caret-right"></i>
          Instituição</label>
        <!-- <div style="display: block; position: relative;top: -15px; color: #787878"><small>Campanha em rede sociais</small></div>-->
      </div>
    </div>
    <div v-if="showFilterInstituicao">
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> PA:</label>
          <div class="input-group">
            <v-select v-model="form.numeroPA.value" :options="form.numeroPA.listOptions" class="w-100"
              label="text" placeholder="Selecione o PA">
              <template v-slot:no-options>Nenhum PA encontrado.</template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Regional:</label>
          <div class="input-group">
            <v-select v-model="form.nomeRegional.value" :options="form.nomeRegional.listOptions" class="w-100"
              label="text" placeholder="Selecione a regional">
              <template v-slot:no-options>Nenhuma regional encontrada.</template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Gerente:</label>
          <div class="input-group w-100">
            <v-select multiple v-model="form.employee.selected" :options="form.employee.listOptions" class="w-100" label="text"
              placeholder="Selecione o gerente">
              <template v-slot:no-options>Nenhum Gerente encontrado.</template>
            </v-select>
          </div>
        </div>
      </div>
    </div>
    <div class="form-group row">
      <div class="w-100">
        <label style="font-size: medium; font-weight: 600;letter-spacing: 0.3px; color: #2e6e60; cursor: pointer"
          @click.prevent="showFilterResponsavel === true ? showFilterResponsavel = false : showFilterResponsavel = true">
          <i v-if="showFilterResponsavel" class="fas fa-caret-down"></i>
          <i v-else class="fas fa-caret-right"></i>
          Responsáveis</label>
        <!-- <div style="display: block; position: relative;top: -15px; color: #787878"><small>Campanha em rede sociais</small> </div>-->
      </div>
    </div>
    <div v-if="showFilterResponsavel">
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Responsáveis:</label>
          <div class="input-group">
            <v-select multiple v-model="form.responsible.selected" :options="form.responsible.listOptions" class="w-100"
              label="text" placeholder="Selecione a pessoa responsável">
              <template v-slot:no-options>Nenhum Reponsável encontrado.</template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Grupos Responsáveis:</label>
          <div class="input-group">
            <v-select multiple v-model="form.groupResponsible.selected" :options="form.groupResponsible.listOptions" class="w-100"
              label="text" placeholder="Selecione o grupo responsável">
              <template v-slot:no-options>Nenhum grupo encontrado.</template>
            </v-select>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="w-100">
        <label style="font-size: medium; font-weight: 600;letter-spacing: 0.3px; color: #2e6e60; cursor: pointer"
          @click.prevent="showFilterProduto === true ? showFilterProduto = false : showFilterProduto = true">
          <i v-if="showFilterProduto" class="fas fa-caret-down"></i>
          <i v-else class="fas fa-caret-right"></i>
          Produtos</label>
        <!-- <div style="display: block; position: relative;top: -15px; color: #787878"><small>Campanha em rede sociais</small></div> -->
      </div>
    </div>
    <div v-if="showFilterProduto">
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Produto:</label>
          <div class="input-group">
            <v-select multiple v-model="form.product.selected" :options="form.product.listOptions" placeholder="Selecione o produto"
              class="w-100" label="text">
              <template v-slot:no-options>Nenhum produto encontrado.</template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Valor:</label>
          <div class="input-group">
            <money id="valorInicial" placeholder="$lang.Currency.Placeholder" class="form-control text-bold"
            max-length="12"
            v-model.lazy="form.valorInicial.value" v-bind="$lang.Currency.Format"></money>
            <money id="valorFinal" placeholder="$lang.Currency.Placeholder" class="form-control text-bold"
                  max-length="12"
                  v-model.lazy="form.valorFinal.value" v-bind="$lang.Currency.Format"></money>
            </div>
            <!-- COMPONENTE FOI MODIFICADO POIS O V-MONEY Ñ DEIXA RESETAR O VALOR -->

          <!-- <div class="input-group mb-1">
            <span class="input-group-addon">De </span>
            <b-form-input ref="valorInicial" v-model="form.valorInicial.value" :state="form.valorInicial.state" type="text" v-money="money" style="text-align: right;" />
          </div>
          <div class="input-group">
            <span class="input-group-addon">Até</span>
            <b-form-input ref="valorFinal" v-model="form.valorFinal.value" :state="form.valorFinal.state" type="text"  v-money="money" style="text-align: right;" />
          </div> -->
        </div>
      </div>
    </div>

    <div class="form-group row">
      <div class="w-100">
        <label style="font-size: medium; font-weight: 600;letter-spacing: 0.3px; color: #2e6e60; cursor: pointer"
          @click.prevent="showFilterGeral=== true ? showFilterGeral = false : showFilterGeral = true">
          <i v-if="showFilterGeral" class="fas fa-caret-down"></i>
          <i v-else class="fas fa-caret-right"></i>
          Geral</label>
        <!-- <div style="display: block; position: relative;top: -15px; color: #787878"><small>Campanha em rede sociais</small></div> -->
      </div>
    </div>
    <div v-if="showFilterGeral">
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Origem:</label>
          <div class="input-group">
            <v-select multiple v-model="form.origin.selected" :options="form.origin.listOptions" placeholder="Selecione o origem"
              class="w-100" label="text">
              <template v-slot:no-options>Nenhuma origem encontrada.</template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Quadro:</label>
          <div class="input-group">
            <v-select multiple v-model="form.board.selected" :options="form.board.listOptions" placeholder="Selecione o quadro"
              class="w-100" label="text">
              <template v-slot:no-options>Nenhum quadro encontrado.</template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Situação:</label>
          <div class="input-group">
            <v-select multiple v-model="form.situacao.selected" :options="form.situacao.options" placeholder="Selecione a situação"
              class="w-100" label="text">
              <template v-slot:no-options>Selecione uma situação</template>
            </v-select>
          </div>
        </div>
      </div>
      <div class="form-group row pb-2">
        <div class="w-100">
          <label> Periodo:</label>
          <div class="mb-1">
            <b-form-input type="date"
                          style="height: 35px;"
                          v-model="form.dataInicial.value"
                          :required="false"
                          :state="form.dataInicial.state"/>
          </div>
          <div>
            <b-form-input type="date"
                          style="height: 35px;"
                          v-model="form.dataFinal.value"
                          :required="false"
                          :state="form.dataFinal.state"/>
          </div>
        </div>
      </div>
    </div>

    <div class="form-group row pt-2">
      <div class="w-100 pt-2">
        <button type="button" class="btn rounded-4 btn-third w-100" v-on:click="onFilter">
          Filtrar
        </button>
      </div>
      <div class="w-100 pt-2">
        <button type="button" class="btn rounded-4 btn-default w-100" v-on:click="onClearFilters">
          Limpar Filtros
        </button>
      </div>
    </div>
    <!-- <div class="form-group row" style="margin-top: 600px;">&nbsp;</div> -->
  </div>
</template>

<script>
import CardSearch from './search.js'
export default CardSearch
</script>

<style lang="scss" scoped>

.disable-text-select {
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}
.animated.fadeIn {
  padding-bottom: 2rem;
}

.animated.fadeIn::-webkit-scrollbar {
  display: none;
}

.form-group {
  margin-left: 0 !important;
  margin-right: 0 !important;
}
</style>



// WEBPACK FOOTER //
// src/views/private/reports/crm/search/search.vue